import SharedSortableLists from './SharedSortableLists'
import AreaDirectorArticleJobsIndex from './AreaDirectorArticleJobsIndex'

export default class AreaDirectorSortableArticleJobsList extends SharedSortableLists {
  reactTableComponent() {
    return AreaDirectorArticleJobsIndex;
  }

  defaultSortKey() {
    return "headline"
  }

  sortData() {
    switch(this.sortKey) {
      case "headline":
        return this.sortBy({attr: "headline_raw"})
        break;
      default:
        return this.sortBy({attr: "page_header_raw"})
        break;
    }
  }

  updateData(key, newData) {
    this.data = newData;
    if ($(`.js-${key}-count`).length) {
      $(`.js-${key}-count`).text(`${key.titleize()} (${newData.length})`)
    }
    this.render();
  }
}
